


































































import anime from "animejs";
import { Vue, Component } from "vue-property-decorator";
import "../helpers/vertical-state";

/**
 * Normalization
 * @param {number} v - Initial value
 * @param {number} vmin - Initial minimum
 * @param {number} vmax - Initial maximun
 * @param {number} tmin - Transformed minimun
 * @param {number} tmax - Transformed maximum
 * @returns {number} - Transformed value
 * @example Math.normalize( 0.5, -1, 1, 10, 20 ); // 17.5
 */

function normalize(v: number, vmin: number, vmax: number, tmin: number, tmax: number): number {
    const NV = Math.max( Math.min( v, vmax ), vmin ),
        DV = vmax - vmin,
        PC = ( NV - vmin ) / DV,
        DT = tmax - tmin;

    return tmin + PC * DT;
};

@Component
class Anim extends Vue {
    public timeline = anime.timeline({
        autoplay: false,
        // @ts-ignore
        duration: 4000,
        easing: "linear"
    });


    public mounted() {
        const circles = this.$el.querySelectorAll("svg circle"),
            char1 = this.$el.querySelectorAll("svg .char1"),
            char2 = this.$el.querySelectorAll("svg .char2"),
            char3 = this.$el.querySelectorAll("svg .char3"),
            char4 = this.$el.querySelectorAll("svg .char4"),
            char5 = this.$el.querySelectorAll("svg .char5"),
            char6 = this.$el.querySelectorAll("svg .char6"),
            char7 = this.$el.querySelectorAll("svg .char7"),
            char8 = this.$el.querySelectorAll("svg .char8"),
            char9 = this.$el.querySelectorAll("svg .char9"),
            char10 = this.$el.querySelectorAll("svg .char10"),
            char11 = this.$el.querySelectorAll("svg .char11"),
            char12 = this.$el.querySelectorAll("svg .char12"),
            char13 = this.$el.querySelectorAll("svg .char13"),
            char14 = this.$el.querySelectorAll("svg .char14"),
            char1shadow = this.$el.querySelectorAll("svg .char1-shadow"),
            char2shadow = this.$el.querySelectorAll("svg .char2-shadow"),
            char3shadow = this.$el.querySelectorAll("svg .char3-shadow"),
            char4shadow = this.$el.querySelectorAll("svg .char4-shadow"),
            char5shadow = this.$el.querySelectorAll("svg .char5-shadow"),
            char6shadow = this.$el.querySelectorAll("svg .char6-shadow"),
            char7shadow = this.$el.querySelectorAll("svg .char7-shadow"),
            char8shadow = this.$el.querySelectorAll("svg .char8-shadow"),
            char9shadow = this.$el.querySelectorAll("svg .char9-shadow"),
            char10shadow = this.$el.querySelectorAll("svg .char10-shadow"),
            char11shadow = this.$el.querySelectorAll("svg .char11-shadow"),
            char12shadow = this.$el.querySelectorAll("svg .char12-shadow"),
            char13shadow = this.$el.querySelectorAll("svg .char13-shadow"),
            char14shadow = this.$el.querySelectorAll("svg .char14-shadow");

        if (this.detectIE()) {
            this.resizeSvg();
            window.addEventListener("resize",this.resizeSvg);
        }

        for (const circle of circles) {
            anime({
                targets: circle,
                r(target: HTMLElement) {
                    const r = target.getAttribute("r") || "1";
                    return parseInt(r) * anime.random(0.5, 1);
                },
                easing: "easeInOutQuad",
                duration: () => anime.random(4000, 8000),
                direction: "alternate",
                loop: true
            });
        }

        this.timeline
            .add({
                targets: char1,
                transform: 'matrix(1.4 0 0 1.4 100 150)', /* matrix(1 0 0 1 100 150)"> */
                opacity: 1,
                offset: 0
            })
            .add({
                targets: char1shadow,
                transform: 'matrix(1 0 0 1 100 100)', /* matrix(1 0 0 1 100 150)"> */
                opacity: 1,
                offset: 0
            })
            .add({
                targets: char2,
                transform: 'matrix(0.866025 0.5 -0.5 0.866025 940 50)',
                opacity: 1,
                offset: 0
            })
            .add({
                targets: char2shadow,
                transform: 'matrix(0.866025 0.3 -0.3 0.866025 900 70)',
                opacity: 1,
                offset: 0
            })
            .add({
                targets: char3,
                transform: 'matrix(1.4 0 0 1.4 1200 60)', /* matrix(1.4 0 0 1.4 1048 60) */
                opacity: 1,
                offset: 50
            })
            .add({
                targets: char3shadow,
                transform: 'matrix(1 0 0 1 1200 0)', /* matrix(1.4 0 0 1.4 1048 60) */
                opacity: 1,
                offset: 50
            })
            .add({
                targets: char4,
                transform: 'matrix(1.2 0 0 1.2 1600 0)', /* matrix(1 0 0 1 1516 0) */
                opacity: 1,
                offset: 50
            })
            .add({
                targets: char4shadow,
                transform: 'matrix(1 0 0 1 1800 0)', /* matrix(1 0 0 1 1516 0) */
                opacity: 1,
                offset: 50
            })
            .add({
                targets: char5,
                transform: 'matrix(1 -0.2 0.2 1 1213 257)', /* matrix(1 0 0 1 1213 257) */
                opacity: 1,
                offset: 100
            })
            .add({
                targets: char5shadow,
                transform: 'matrix(1 -0.1 0.1 1 1213 257)', /* matrix(1 0 0 1 1213 257) */
                opacity: 1,
                offset: 100
            })
            .add({
                targets: char6,
                transform: 'matrix(1 0.6 -0.6 1 550 365)', /* matrix(1 0 0 1 450 365) */
                opacity: 1,
                offset: 0
            })
            .add({
                targets: char6shadow,
                transform: 'matrix(1.1 0.2 -0.2 1.1 440 390)', // matrix(1 0 0 1 450 365)
                opacity: 1,
                offset: 0
            })
            .add({
                targets: char7,
                transform: 'matrix(1.2 0 0 1.2 805 476)', /* matrix(1 0 0 1 834 472) */
                opacity: 1,
                offset: 50
            })
            .add({
                targets: char7shadow,
                transform: 'matrix(1.1 -0.2 0.2 1.1 760 520)', /* matrix(1 0 0 1 834 472) */
                opacity: 1,
                offset: 50
            })
            .add({
                targets: char8,
                transform: 'matrix(1.1 -0.2 0.2 1.1 1100 450)', /* matrix(1 0 0 1 1213 471) */
                opacity: 1,
                offset: 0
            })
            .add({
                targets: char8shadow,
                transform: 'matrix(1.2 0 0 1.2 1213 500)', /* matrix(1 0 0 1 1213 471) */
                opacity: 1,
                offset: 0
            })
            .add({
                targets: char9,
                transform: 'matrix(1 -0.5 0.5 1 1540 370)', /* matrix(1 0 0 1 1598 341) */
                opacity: 1,
                offset: 50
            })
            .add({
                targets: char9shadow,
                transform: 'matrix(1 -0.7 0.7 1 1480 370)', /* matrix(1 0 0 1 1598 341) */
                opacity: 1,
                offset: 50
            })
            .add({
                targets: char10,
                transform: 'matrix(1.2 -0.4 0.4 1.2 150 900)', /* matrix(1 0 0 1 450 717) */
                opacity: 1,
                offset: 100
            })
            .add({
                targets: char10shadow,
                transform: 'matrix(1.2 -0.4 0.4 1.2 150 900)', /* matrix(1 0 0 1 450 717) */
                opacity: 1,
                offset: 100
            })
            .add({
                targets: char11,
                transform: 'matrix(1.2 -0.7 0.7 1.2 600 840)', /* matrix(1 0 0 1 718 790) */
                opacity: 1,
                offset: 50
            })
            .add({
                targets: char11shadow,
                transform: 'matrix(1.2 -0.6 0.6 1.2 620 840)', /* matrix(1 0 0 1 718 790) */
                opacity: 1,
                offset: 50
            })
            .add({
                targets: char12,
                transform: 'matrix(1.1 -0.4 0.4 1.1 1048 817)', /* matrix(1 0 0 1 1048 717) */
                opacity: 1,
                offset: 0
            })
            .add({
                targets: char12shadow,
                transform: 'matrix(1.1 -0.6 0.6 1.1 1000 817)', /* matrix(1 0 0 1 1048 717) */
                opacity: 1,
                offset: 0
            })
            .add({
                targets: char13,
                transform: 'matrix(1.2 0.4 -0.4 1.2 1500 700)', /* matrix(1 0 0 1 1450 830) */
                opacity: 1,
                offset: 50
            })
            .add({
                targets: char13shadow,
                transform: 'matrix(1.2 0.2 -0.2 1.2 1400 700)', /* matrix(1 0 0 1 1450 830) */
                opacity: 1,
                offset: 50
            })
            .add({
                targets: char14,
                transform: 'matrix(1.2 0 0 1.2 1650 700)', /* matrix(1 0 0 1 1639 717) */
                opacity: 1,
                offset: 50
            })
            .add({
                targets: char14shadow,
                transform: 'matrix(1.1 -0.2 0.2 1.1 1600 700)', /* matrix(1 0 0 1 1639 717) */
                opacity: 1,
                offset: 50
            });

        requestAnimationFrame(this.animate);
    }

    animate() {
        const top = this.$el.verticalState.topProgress;
        const bottom = this.$el.verticalState.bottomProgress;

        // console.log("topProgress:" + this.$el.verticalState.topProgress);
        // console.log("verticalState:" + this.$el.verticalState.top);
        const height = top - bottom;
        const max = 1 + height;
        const ratio = this.$el.verticalState.top / this.$el.offsetHeight;
        this.timeline.seek(normalize(top + ratio, 1, max, 0, 4000));

        // [TODO] optimize with Intersection Observer and start/stop is on/off viewport
        requestAnimationFrame(this.animate);
    }

    resizeSvg(){
        const svg = this.$el.querySelector("svg");
        if(svg) {
          if(window.innerWidth > 767){
            const height = svg.getBoundingClientRect().width / svg.viewBox.baseVal.width * svg.viewBox.baseVal.height;
            svg.setAttribute("height", height.toString());
            svg.removeAttribute("style");
          } else {
            const height = window.innerHeight * 0.66;
            const width =  svg.viewBox.baseVal.width / svg.viewBox.baseVal.height * height ;
            svg.setAttribute("height", height.toString());
            svg.setAttribute("width", width.toString());
            svg.style.width = width + "px";
          }
        }
    }

    detectIE() {

        /**
         * detect IE
         * returns version of IE or false, if browser is not Internet Explorer
         */

        const ua = window.navigator.userAgent;

        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

        // Edge 12 (Spartan)
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

        // Edge 13
        // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

        const msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            // IE 10 or older => return version number
            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }

        const trident = ua.indexOf('Trident/');
        if (trident > 0) {
            // IE 11 => return version number
            var rv = ua.indexOf('rv:');
            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }

        const edge = ua.indexOf('Edge/');
        if (edge > 0) {
            // Edge (IE 12+) => return version number
            return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
        }

        // other browser
        return false;
    }
}

export default Anim;



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/anim.vue